import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";

export default function LandingPage() {
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const openBooking = (service = null) => {
    setSelectedService(service);
    setOpen(true);
  };

  return (
    <main data-testid="landing-page" className="bg-[#0A0A0C] min-h-screen">
      <Header onBookClick={() => openBooking(null)} />
      <Hero onBookClick={() => openBooking(null)} />
      <Services onBookService={(svc) => openBooking(svc)} />
      <About />
      <Testimonials />
      <Footer onBookClick={() => openBooking(null)} />

      <BookingDialog
        open={open}
        onOpenChange={setOpen}
        initialService={selectedService}
      />
    </main>
  );
}
